import React from 'react';
import './style.scss';

interface EmptyListProps {
    handleNewList?: (event: React.MouseEvent) => void;
    title: string;
    buttonTitle?: string;
    icon: string;
}

const EmptyList: React.FC<EmptyListProps> = ({ handleNewList, title, buttonTitle, icon }: EmptyListProps) => {
    return (
        <div className="empty-list">
            <i className="material-icons-outlined icon-center" id="file">
                {icon}
            </i>
            <h1>{title}</h1>

            {!!handleNewList && (
                <button className="btn btn-primary btn-lg m-top--sm" onClick={handleNewList} type="button">
                    <span className="align-middle">{buttonTitle}</span>
                </button>
            )}
        </div>
    );
};

export default EmptyList;
